module.exports = __webpack_public_path__ + "img/pr-4.49e383ee.png";